import React from "react";
import reviewGatheringCardIcon from "assets/review_gathering.svg";
import CONSTANTS from "constants/constants";

const { MARKET_PULSE } = CONSTANTS;

const ReviewGatheringCard = () => (
  <div className="review-gathering-card-flex">
    <div className="review-gathering-card-graphic">
      <img src={reviewGatheringCardIcon} alt="Review Gathering Card" className="marketpulse-img" />
    </div>
    <div className="review-gathering-card-content">
      <div className="review-gathering-card-title">
        <span className="review-gathering-card-title-highlight">{MARKET_PULSE.REVIEW_TITLE_HIGHLIGHT}</span> {MARKET_PULSE.REVIEW_TITLE}
      </div>
      <ul className="review-gathering-card-list">
        <li>
          <span className="dashboard-card-dot" />
          <span className="review-gathering-card-list-title">{MARKET_PULSE.REVIEW_LIST_1_TITLE}</span>
        </li>
        <li>
          <div className="review-gathering-card-list-desc">{MARKET_PULSE.REVIEW_LIST_1_DESC}</div>
        </li>
        <li>
          <span className="dashboard-card-dot" />
          <span className="review-gathering-card-list-title">{MARKET_PULSE.REVIEW_LIST_2_TITLE}</span>
        </li>
        <li>
          <div className="review-gathering-card-list-desc">{MARKET_PULSE.REVIEW_LIST_2_DESC}</div>
        </li>
      </ul>
    </div>
  </div>
);

export default ReviewGatheringCard; 
